"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditCoverageDetailsModal = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var workflow_1 = require("@newfront-insurance/workflow");
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var react_error_boundary_1 = require("react-error-boundary");
var definitions_1 = require("../../../hooks/definitions");
var coverage_input_1 = require("../../coverage-input");
function EditCoverageDetailsModal(_a) {
    var _this = this;
    var identifier = _a.identifier, lineOfCoverageDetails = _a.lineOfCoverageDetails, isModalOpen = _a.isModalOpen, onSetIsModalOpen = _a.onSetIsModalOpen, onUpdate = _a.onUpdate;
    var version = lineOfCoverageDetails.version, type = lineOfCoverageDetails.type, displayName = lineOfCoverageDetails.displayName;
    var targetRef = react_1.default.createRef();
    var renderLineOfCoverageType = definitions_1.useDefinitionsHelpers().renderLineOfCoverageType;
    var initialValues = {
        coverage: lineOfCoverageDetails,
    };
    var form = workflow_1.useForm({
        initialValues: initialValues,
        onSubmit: function (values) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, onUpdate(values.coverage)];
                    case 1:
                        _b.sent();
                        onSetIsModalOpen();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        form.setValues(initialValues);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); },
    }).form;
    var onCancel = function () {
        onSetIsModalOpen();
        return form.setValues(initialValues);
    };
    var title = displayName ? renderLineOfCoverageType(type) + " - " + displayName : renderLineOfCoverageType(type);
    return (react_1.default.createElement(core_ui_1.Modal, { key: "modal-" + identifier, hideOnClickOutside: true, innerRef: targetRef, overlayBgColor: "black", overlayOpacity: 0.3, isOpen: isModalOpen, onToggle: onSetIsModalOpen },
        react_1.default.createElement(core_ui_1.ModalBody, null,
            react_1.default.createElement(core_ui_1.ModalHeader, { onClose: onSetIsModalOpen, titleText: "Edit " + title }),
            react_1.default.createElement(core_ui_1.Padding, { size: 32 },
                react_1.default.createElement(formik_1.FormikProvider, { value: form },
                    react_1.default.createElement("form", { onSubmit: form.handleSubmit },
                        react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(core_ui_1.CircleSpinner, { label: "Loading coverage details..." }) },
                            react_1.default.createElement(react_error_boundary_1.ErrorBoundary, { fallback: react_1.default.createElement(core_ui_1.Alert, null, "There was a problem loading the coverage form.") },
                                react_1.default.createElement(coverage_input_1.CoverageInput, { name: "coverage", lineOfCoverageType: type, lineOfCoverageVersion: version })))))),
            react_1.default.createElement(core_ui_1.ModalFooter, null,
                react_1.default.createElement(core_ui_1.Stack, { gap: 8, direction: "horizontal" },
                    react_1.default.createElement(core_ui_1.Button, { onClick: onCancel, size: "secondary" }, "Cancel"),
                    react_1.default.createElement(core_ui_1.Button, { loading: form.isSubmitting, onClick: form.submitForm }, "Save"))))));
}
exports.EditCoverageDetailsModal = EditCoverageDetailsModal;
